import { differenceInDays, startOfDay } from 'date-fns';
import { t } from 'i18next';

export default function dDayCalculate(startDate: string, endDate: string) {
  const { openDday, endDday } = calculateDayOnly(startDate, endDate);

  /*
   * 날짜 차이 기반 D-day 계산:
   * - openDday > 0: 시작 전 → 오픈 D-{openDday}
   * - openDday <= 0 && endDday > 0: 진행 중 → 종료 D-{endDday}
   * - endDday = 0: 종료 당일 → 오늘 종료
   * - endDday < 0: 종료됨 → 종료
   */
  const dDay =
    openDday > 0
      ? t('DDay.openDday', { day: openDday })
      : endDday > 0
        ? t('DDay.endDday', { day: endDday })
        : endDday === 0
          ? t('DDay.todayEnd')
          : t('DDay.nowEnd');

  return dDay;
}

// dDay 상태 반환
export function dDayStateCalculate(startDate: string, endDate: string) {
  const { openDday, endDday } = calculateDayOnly(startDate, endDate);

  /*
   * 날짜 차이 기반 상태 계산:
   * - openDday > 0: 시작 전
   * - openDday <= 0 && endDday > 0: 진행 중
   * - endDday = 0: 종료 당일
   * - endDday < 0: 종료됨
   */
  const dDayState =
    openDday > 0
      ? 'before' // 시작 전
      : endDday > 0
        ? 'ongoing' // 진행 중
        : endDday === 0
          ? 'endingToday' // 종료 당일
          : 'ended'; // 종료

  return dDayState;
}

// export function calculateDayOnly(
//   startDate: string,
//   endDate: string
// ): { openDday: number; endDday: number } {
//   // 현재 날짜를 자정(00:00:00)으로 설정하여 날짜만 비교
//   const nowDate = new Date();
//   nowDate.setHours(0, 0, 0, 0);

//   const startDateTime = new Date(startDate);
//   startDateTime.setHours(0, 0, 0, 0);

//   const endDateTime = new Date(endDate);
//   endDateTime.setHours(0, 0, 0, 0);

//   // 밀리초 차이를 일수로 변환 (Math.ceil 대신 정확한 일수 계산)
//   const openDday = Math.round((startDateTime.getTime() - nowDate.getTime()) / (1000 * 60 * 60 * 24));
//   const endDday = Math.round((endDateTime.getTime() - nowDate.getTime()) / (1000 * 60 * 60 * 24));

//   return { openDday, endDday };
// }

// date-fns를 사용한 대안 방법
export function calculateDayOnly(
  startDate: string,
  endDate: string
): { openDday: number; endDday: number } {
  const today = startOfDay(new Date());
  const start = startOfDay(new Date(startDate));
  const end = startOfDay(new Date(endDate));

  const openDday = differenceInDays(start, today);
  const endDday = differenceInDays(end, today);

  return { openDday, endDday };
}
